import graphql from "babel-plugin-relay/macro";

export const CreatePolicyQuery = graphql`
  query CreatePolicyQuery(
    $documentPk: Int
    $templatePk: Int
    $documentSavePk: Int
  ) {
    documentCreate(
      pk: $documentPk
      templatePk: $templatePk
      documentSavePk: $documentSavePk
    ) {
      document {
        ...commentForm_document
        id
        pk
        name
        status
        actions(isEditPage: false) {
          id
          pk
          actionType
          actionDate
          canEdit
          comment
          isExternal
          user {
            id
            userDisplay(userDisplayType: FORWARD)
          }
        }
        systemDocumentTemplate {
          pk
        }
      }
      documentSave {
        pk
        savedCopy {
          pk
          author {
            pk
            firstName
            lastName
            email
          }
        }
      }
      editForm {
        name
        author {
          pk
          firstName
          lastName
          title
        }
        category {
          pk
          name
        }
        categoryChoices {
          pk
          name
        }
        flowTemplate {
          pk
          name
        }
        flowTemplateChoices {
          pk
          name
        }
        bloc {
          pk
          name
        }
        blocChoices {
          pk
          name
        }
        html
        activeLifespan
        expirationDate
        isAForm
        restricted
        regulations
        onesourceDocuments {
          oneSourceDocumentId
          catalogNumber
          manufacturerName
          revisionInformation
          viewUrl
        }
      }
      tagForm {
        tags {
          pk
          name
        }
      }
      saveForm {
        hasSavedCopy
        continueDraft
        timestamp
      }
      scheduledEffectiveDateForm {
        effectiveDate
        effectiveDateTimedelta
        effectiveDateAlgorithm
      }
      error {
        statusCode
        message
      }
      rtlSupport
      newCkeditor
      ckeditor5
      redirectUrl
      policyActions
      canLocalize
    }
  }
`;

export default CreatePolicyQuery;
